/*
<LKRequestButton
  APICall={Function} - function that returns promise
  APICallParams={Object} - arguments list to pass to api call
  isDisabled={Function} - returns disabled flag (true | false)
  icon={String} - icon alias
  confirmation={Boolean} - needs to open confirmation modal or not
  confirmationName={String} - confirmation modal name
  confirmationMessage={String} - message to display on confirmation modal (default: r u sure?)
  permission={String} - action permission
/>
*/

import React from 'react'
import { connect } from 'react-redux'

import { translate } from 'loankeeper-common/helpers'
import withConstantPermissions from './containers/withConstantPermissions'
import LKModal, { actions as LKModalActions } from './LKModal'
import LKButton from './LKButton'

const translateLKMessage = (key) => translate(`LKMESSAGE-${key}`)

@withConstantPermissions()
@connect()
class LKRequestButton extends React.Component {
  state = { loading: false }

  handleRequest = async () => {
    const { APICall, APICallParams, onSuccessActions, dispatch, confirmation, confirmationName } = this.props

    this.setState({ loading: true })

    // APICall({
    //   ID: APICallParams.ID,
    //   // HashSum_EntryID_: APICallParams.hash,
    //   // hash: APICallParams.hash,
    //   OID: APICallParams.OID,
    //   HashSum_OID_: APICallParams.OIDHash,
    //   action: APICallParams.action
    // })
    //   .then((response) => {
    //     this.setState({ loading: false })

    //     if (response.Error && response.Error.Code !== 0) {
    //       throw new Error('Something went wrong')
    //     }

    //     if (onSuccessActions) {
    //       if (Array.isArray(onSuccessActions)) {
    //         onSuccessActions.forEach(dispatch)
    //       } else {
    //         dispatch(onSuccessActions)
    //       }
    //     }
    //   })
    //   .catch((error) => {
    //     this.setState({ loading: false })

    //     if (error.Error) {
    //       dispatch(LKModalActions.openInfo(translateLKMessage(error.Error.Message || error.Error.Text)))
    //     }

    //     console.error(error)
    //   })
    //   .finally(() => {
    //     if (confirmation) {
    //       dispatch(LKModalActions.close(confirmationName))
    //     }
    //   })

    try {
      const params = {
        ID: APICallParams.ID,
        HashSum_EntryID_: APICallParams.HashSum_EntryID_,
        OID: APICallParams.OID,
        HashSum_OID_: APICallParams.OIDHash,
        action: APICallParams.action,
        ...APICallParams,
      }

      delete params.OIDHash

      const response = await APICall(params)
      this.setState({ loading: false })
      if ((response?.payload?.code && response?.payload?.code !== 0) || response.Error) {
        throw new Error(
          response?.payload?.message || response?.Error?.Message || response?.Error?.Text || 'Something went wrong',
        )
      }

      if (onSuccessActions) {
        if (Array.isArray(onSuccessActions)) {
          onSuccessActions.forEach(dispatch)
        } else {
          dispatch(onSuccessActions)
        }
      }
    } catch (error) {
      this.setState({ loading: false })

      if (error.message || error.Error) {
        dispatch(
          LKModalActions.openInfo(translateLKMessage(error.message || error?.Error?.Message || error?.Error?.Text)),
        )
      }

      console.error(error)
    } finally {
      if (confirmation) {
        dispatch(LKModalActions.close(confirmationName))
      }
    }
  }

  isDisabled = () => {
    const { isDisabled, permission, permissions } = this.props

    if (isDisabled && isDisabled(this.props)) {
      return true
    }

    if (permission && !permissions[permission]) {
      return true
    }

    return this.state.loading
  }

  render() {
    const { loading } = this.state
    const { icon, children, fluid, confirmation, confirmationName, confirmationMessage, style, dispatch } = this.props

    return (
      <>
        {confirmation && (
          <LKModal.Confirmation name={confirmationName} loading={loading} onConfirm={this.handleRequest} />
        )}
        <LKButton
          disabled={this.isDisabled()}
          fluid={fluid}
          loading={loading}
          alias={icon}
          style={style}
          onClick={
            confirmation
              ? () =>
                  dispatch(
                    LKModalActions.openConfirmation(confirmationName, {
                      message: confirmationMessage || translate('LKMESSAGE-MSG_ARE_YOU_SURE'),
                    }),
                  )
              : this.handleRequest
          }
        >
          {children}
        </LKButton>
      </>
    )
  }
}

export default LKRequestButton
